import { useMemo } from 'react'

import getAnonymousId from 'utils/getAnonymousId'

export function useSegmentAnonymousId(): string {
  const anonymousId = useMemo(() => getAnonymousId(), [])

  return anonymousId
}
